import { render, staticRenderFns } from "./QuantitySelector.vue?vue&type=template&id=b333732c&"
import script from "./QuantitySelector.vue?vue&type=script&lang=js&"
export * from "./QuantitySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusIcon: require('/~/src/modules/opus/components/Icon.vue').default})
